<sm-form #formComponent class="width100p" [form]="form"></sm-form>